import commonTableColumns from '@root/components/table/commonTableColumns';
import Text from '@root/components/v2/ui-elements/Text';
import Tooltip from '@root/components/v2/ui-elements/Tooltip';
import { VulnerabilityCounts } from '../VulnerabilityCounts';
// import atlassian_jira_logo_icon from '@assets/svg/atlassian_jira_logo_icon.svg';
import WorkloadVulnerabilities from '@root/assets/svg/Kubernetes/WorkloadVulnerabilities';
// import fix_available_check from '@root/assets/svg/workload/green_tick_icon_new.svg';
import info from '@root/assets/svg/workload/info.svg';
import question1 from '@root/assets/svg/workload/question1.png';
import { SeverityWithText } from '@root/components/bootstrapTable/badges/severity';
import { Box } from '@mui/material';
import { severityDarkColors, severityLightColors } from '@root/components/bootstrapTable/badges/severity';

export const hostLevelColumns = [
  commonTableColumns.environment('account_id', 'cluster'),
  {
    field: 'node_name',
    headerName: 'Node',
    copyData: { key: 'node_name' },
    width: 200,
    renderCell: params => {
      return (
        <Tooltip tooltip={params.row.node_name}>
          <Text className="SingleLine">{params.row.node_name}</Text>
        </Tooltip>
      );
    },
  },
  {
    field: 'instance_id',
    headerName: 'Instance ID',
    copyData: { key: 'instance_id' },
    width: 200,
    renderCell: params => {
      return (
        <Tooltip tooltip={params.row.instance_id}>
          <Text className="SingleLine">{params.row.instance_id}</Text>
        </Tooltip>
      );
    },
  },
  {
    field: 'ami_id',
    headerName: 'AMI ID',
    copyData: { key: 'ami_id' },
    width: 200,
    renderCell: params => {
      return (
        <Tooltip tooltip={params.row.ami_id}>
          <Text className="SingleLine">{params.row.ami_id}</Text>
        </Tooltip>
      );
    },
  },

  // {
  //   field: 'cluster',
  //   headerName: 'Cluster',
  //   width: 230,
  // },

  {
    field: 'vulnerabilities',
    headerName: 'Vulnerabilities',
    width: 250,
    renderCell: params => {
      return params?.row?.vulnerabilities ? <VulnerabilityCounts vulnerabilities={params.row.vulnerabilities} /> : '-';
    },
  },
];

export const k8columns = () => {
  return [
    commonTableColumns.environment('account_id'),
    {
      field: 'cluster',
      headerName: 'Cluster',
      classes: 'align-middle',
      // headerClassName: 'fs__2'
      minWidth: 200,
      sortable: false,
      renderCell: params => {
        return (
          <Tooltip title={params.row?.cluster}>
            <Text fontWeight={500} className="SingleLine">
              {params.row?.cluster ?? '-'}
            </Text>
          </Tooltip>
        );
      },
    },
    {
      field: 'cve_id',
      headerName: 'CVE ID',
      classes: 'align-middle',
      // headerClassName: 'fs__2'
      minWidth: 200,
      sort: true,
      renderCell: params => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Box sx={{ background: 'rgb(243, 244, 246)', padding: '5px', borderRadius: '.5rem' }}>
              {' '}
              <WorkloadVulnerabilities height="16px" width="16px" />{' '}
            </Box>

            <Tooltip title={params.row?.cve_id}>
              <Text fontWeight={500} style={{ width: '170px' }} className="SingleLine">
                {params.row?.cve_id}
              </Text>
            </Tooltip>
          </div>
        );
      },
    },

    {
      field: 'severity',
      headerName: 'CVSS Severity',
      classes: 'align-middle',
      // headerClassName: 'fs__2'
      minWidth: 200,
      sort: true,
      renderCell: params => {
        return (
          <Tooltip title={params.row.severity}>
            {params.row?.severity.toUpperCase() !== 'INFORMATIONAL' ||
            params.row?.severity.toUpperCase() !== 'UNTRIAGED' ? (
              // <HighIcon textDisabled={true} />
              <SeverityWithText propsValue={params.row?.severity} />
            ) : params.row?.severity.toUpperCase() === 'INFORMATIONAL' ? (
              <img
                src={info}
                style={{
                  height:
                    params.row?.severity.toUpperCase() === 'INFORMATIONAL' ||
                    params.row?.severity.toUpperCase() === 'UNTRIAGED'
                      ? '30px'
                      : '',
                  width:
                    params.row?.severity.toUpperCase() === 'INFORMATIONAL' ||
                    params.row?.severity.toUpperCase() === 'UNTRIAGED'
                      ? '30px'
                      : '',
                }}
              />
            ) : (
              <img
                src={question1}
                style={{
                  height:
                    params.row?.severity.toUpperCase() === 'INFORMATIONAL' ||
                    params.row?.severity.toUpperCase() === 'UNTRIAGED'
                      ? '30px'
                      : '',
                  width:
                    params.row?.severity.toUpperCase() === 'INFORMATIONAL' ||
                    params.row?.severity.toUpperCase() === 'UNTRIAGED'
                      ? '30px'
                      : '',
                }}
              />
            )}
          </Tooltip>
        );
      },
    },
    {
      field: 'cvss_score',
      headerName: 'CVSS Score',
      classes: 'align-middle',
      minWidth: 200,
      sort: true,
      renderCell: params => {
        const score = params.row?.['cvss_score'] === 0 ? 0 : parseFloat(params.row?.['cvss_score']).toFixed(1);
        const colorSeverity = params.row?.severity;

        const backgroundDarkColor = severityDarkColors[colorSeverity?.toUpperCase()] || severityDarkColors.DEFAULT;
        const backgroundLightColor = severityLightColors[colorSeverity?.toUpperCase()] || severityLightColors.DEFAULT;

        // const version = `v${params.row?.details?.Vector ?? '3.0'}`;
        const version = params.row?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.version
          ? `v${params.row.details.cvssMetricV31.cvssMetricV31?.[0]?.cvssData?.version}`
          : params.row?.details?.Vector?.match(/CVSS:(\d+\.\d+)/)?.[1]
          ? `v${params.row.details.Vector.match(/CVSS:(\d+\.\d+)/)[1]}`
          : 'v3.0';

        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              borderRadius: '5px',
              overflow: 'hidden',
            }}>
            <div
              style={{
                backgroundColor: backgroundDarkColor,
                padding: '3px 7px',
                color: '#FFFFFF', // Dark gray for better readability on pastel backgrounds
                fontFamily: 'Manrope',
                fontWeight: 500,
                fontSize: '12px',
              }}>
              {score === 'NaN' ? 0 : score}
            </div>
            <div
              style={{
                backgroundColor: backgroundLightColor,
                padding: '3px 7px',
                color: '#5D0E61', // Dark gray for better readability
                fontFamily: 'Manrope',
                fontWeight: 500,
                fontSize: '12px',
              }}>
              {version}
            </div>
          </div>
        );
      },
    },
    {
      field: 'vul_classification',
      headerName: 'Vulnerability Type',
      classes: 'align-middle',
      minWidth: 200,
      sortable: false,
      renderCell: params => {
        return params.row?.vul_classification?.vulnerability_type
          ? params.row?.vul_classification?.vulnerability_type
          : '-';
      },
    },
    {
      field: 'package_type',
      headerName: 'Package Type',
      classes: 'align-middle',
      minWidth: 200,
      sortable: false,
      renderCell: params => {
        return params.row?.package_type ? params.row?.package_type : '-';
      },
    },
    // {
    //   field: 'cve_risk',
    //   headerName: 'CVE Risks',
    //   classes: 'align-middle',
    //   // headerClassName: 'fs__2'
    //   minWidth: 200,
    //   sortable: false,
    //   renderCell: params =>
    //     params.row?.cve_risk === '-' || params.row?.cve_risk?.length === 0 ? (
    //       '-'
    //     ) : (
    //       <div style={{ display: 'flex', gap: '10px' }}>
    //         {params.row?.cve_risk?.exploit && (
    //           <Tooltip title={'Exploit'} isIcon={true}>
    //             <img src={exploit} />
    //           </Tooltip>
    //         )}

    //         {params.row?.cve_risk?.internet_exposed && (
    //           <Tooltip title={'Internet Exposed'} isIcon={true}>
    //             <img src={exposed} />
    //           </Tooltip>
    //         )}
    //       </div>
    //     ),
    // },

    {
      field: 'epss_score',
      headerName: 'EPSS Score',
      classes: 'align-middle',
      // headerClassName: 'fs__2'
      minWidth: 200,
      sortable: false,
      renderCell: params => {
        return (
          <Tooltip title={'params.row.threat_trend_data.Vendor'}>
            <Text fontWeight={500} className="SingleLine">
              {(params.row?.exploitability_score ?? 0).toFixed(2)}
            </Text>
          </Tooltip>
        );
      },
    },
    {
      field: 'exploitable',
      headerName: 'Exploitable',
      classes: 'align-middle',
      // headerClassName: 'fs__2'
      minWidth: 200,
      sortable: false,
      renderCell: params => {
        return params?.row?.exploitable ? 'Yes' : 'No';
      },
    },

    {
      field: 'fix_version',
      headerName: 'Fix Version',
      renderCell: params => {
        return params?.row?.fix_version ?? '-';
      },
      width: 250,
    },
  ];
};
